import React from 'react'
import { ReactComponent as DiagArrow } from '@/shared/assets/diagArrow.svg'
import { classNames } from '@/shared/lib/utils/classNames'
import cls from './Button.module.scss'

export const Button = ({ children, variant, className, onClick }) => {
    const variants = {
        primary: cls.primary,
        gradient: cls.gradient,
    }
    return (
        <button
            onClick={onClick}
            className={classNames(cls.Button, [variants[variant], className])}
        >
            {children}
            <DiagArrow className={cls.DiagArrow} />
        </button>
    )
}
